import { render, staticRenderFns } from "./catalogue-detail-redeem.vue?vue&type=template&id=56e63838"
import script from "./catalogue-detail-redeem.vue?vue&type=script&lang=js"
export * from "./catalogue-detail-redeem.vue?vue&type=script&lang=js"
import style0 from "./catalogue-detail-redeem.vue?vue&type=style&index=0&id=56e63838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports